import Link from "@mui/material/Link";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect, useState, useRef, useMemo } from "react";
import {
  updateFilterConfig,
  resetFilterConfigSelections,
  getFilterConfigsTableData,
  getFilterConfigById,
  setModuleConfigData,
  getFilteredFields,
  setFilteredFields,
  setMandatoryFieldsInScreen,
} from "../../../../actions/filterAction";
import { addSnack } from "../../../../actions/snackbarActions";
import {
  saveIngestionConfig,
  saveMappingTableConfig,
} from "../../../../actions/tenantConfigActions";
import moment from "moment";
// import AgGrid from "Utils/agGrid";
import AgGridComponent from "Utils/agGrid";
import agGridColumnFormatter from "Utils/agGrid/column-formatter";
import LoadingOverlay from "Utils/Loader/loader";
import ConfirmPrompt from "commonComponents/confirmPrompt";
import { captializeStringIfCamelCase } from "Utils/formatter";
import { dynamicLabelsBasedOnTenant } from "Utils/DynamicLabels";
import axiosInstance from "Utils/axios";
import {
  DATAINGESTION_TENANT_CONFIG_GET_ALL,
  DATAPLATFORM_SOURCING_MAPPING_CONFIG,
} from "modules/dataIngestion/constants-dataIngestion/apiConstants";
import axiosPlatformInstance from "Utils/axiosPlatform";
import { homePageActions } from "actions/homePageActions";
import {
  DELETE,
  EDIT,
  SOURCING_MAPPING_MODULE,
} from "modules/dataIngestion/constants-dataIngestion/moduleConstants";
import { getModuleLevelAccess, deleteMappingConfig } from "modules/dataIngestion/services-dataIngestion/dataIngestion-combined-service";
import { updateSubModuleStatus } from "actions/dataIngestionActions";
import globalStyles from "Styles/globalStyles";
import { MAPPING_TABLE_COLS } from "modules/dataIngestion/constants-dataIngestion/csvCols";
import { handleDownloadCSVTemplate } from "modules/dataIngestion/common-components/functions/common_functions";

const useStyles = makeStyles({
  moduleTitle: {
    fontSize: 20,
    fontWeight: 500,
  },
  dialogActions: {
    background: "#F9F9F9",
    marginRight: "2%",
  },
  highLightUploadedData: {
    background: "#DEEEFF !important"
  }
});

const SourceMappingConfigTable = (props) => {
  const globalClasses = globalStyles();
  const classes = useStyles()
  const [isLoading, setLoadingStatus] = useState(false);
  const [screenConfig, setScreenConfig] = useState([]);
  const [open, setOpen] = useState(false);
  const [filterConfigsTableColumns, setfilterConfigsTableColumns] = useState(
    []
  );
  const [showDeleteConfirmModal, updateShowDeleteConfirmModal] = useState(
    false
  );
  const [currentConfigToDelete, updateCurrentConfigToDelete] = useState(null);
  const configMappingTableRef = useRef(null);
  const [configTableData, setConfigTableData] = useState([]);
  let [userScreenLevelAccess, setUserScreenLevelAccess] = useState({});

  useEffect(async () => {
    const userAccessData = await props.getModuleLevelAccess(
      "dataingestion",
      SOURCING_MAPPING_MODULE
    );
    setUserScreenLevelAccess(userAccessData.data.data);
  }, []);

  const handleClose = () => {
    props.resetFilterConfigSelections();
    setOpen(false);
  };

  const manualCallBack = async (body, pageIndex, params) => {
    const manualbody = {
      filters: body,
    };
    // const response = await props.getFilterConfigsTableData(
    //   manualbody,
    //   pageIndex,
    //   10
    // );
    let data = await getTenantFilterConfig();
    return {
      totalCount: data.data.length,
      data: data.data,
    };
  };

  const getTenantFilterConfig = async () => {
    setLoadingStatus(true);
    props.setRenderMappingAgGrid(true);
    const { data } = await axiosPlatformInstance({
      url: `${DATAPLATFORM_SOURCING_MAPPING_CONFIG}`,
      method: "GET",
    });
    setLoadingStatus(false);
    props.setSelectedRows([]);
    props.updateSubModuleStatus(data?.data && data?.data.length ? false : true)
    // return JSON.parse(JSON.stringify({"total":null,"page":null,"count":null,"status":true,"data":[{"tenant":"Vera Bradley","table":"receipt","connector":"MSSQL","view":"VW_FACT_SALES_ORDER_LINE_ITEM","source_config":"BYOD_db_config","pull_type":"incremental","replace":false,"schedule_interval":"0 3 * * *","intermediate_table":"receipt_intermediate","filter":"SYNCSTARTDATETIME","dataingestion_filterparam":"2023-04-13T08:31:54","filter_param":"2023-04-13T08:31:54","extraction_sync_dt":"2023-04-13T08:31:54","source_format_regex":"","inter_query_exec_order":2,"partition_column":"SYNCSTARTDATETIME","clustering_columns":"ETIME","query_partitioning_threshold":1000000000,"num_partitions":null,"db_partition_column":null,"field_delimiter":"|","is_deleted":false,"created_by":3,"created_at":"2023-05-03T10:44:31.113665+00:00","updated_by":NaN,"updated_at":"NaT","deleted_by":null,"deleted_at":null},{"tenant":"Vera Bradley","table":"po","connector":"MSSQL","view":"VW_FACT_SALES_ORDER_LINE_ITEM","source_config":"BYOD_db_config","pull_type":"incremental","replace":false,"schedule_interval":"0 3 * * *","intermediate_table":"receipt_intermediate","filter":"SYNCSTARTDATETIME","dataingestion_filterparam":"2023-04-12T08:31:54","filter_param":"2023-04-12T08:31:54","extraction_sync_dt":"2023-04-12T08:31:54","source_format_regex":"(csv|dat|csv.gz|dat.gz)","inter_query_exec_order":2,"partition_column":"SYNCSTARTDATETIME","clustering_columns":"ETIME","query_partitioning_threshold":1000000000,"num_partitions":null,"db_partition_column":null,"field_delimiter":"|","is_deleted":false,"created_by":3,"created_at":"2023-05-04T05:39:30.025070+00:00","updated_by":NaN,"updated_at":"NaT","deleted_by":null,"deleted_at":null},{"tenant":"signet","table":"table","connector":"connector","view":"view","source_config":"signet_config","pull_type":"incremental","replace":true,"schedule_interval":"30 9 * * *","intermediate_table":"transaction_intermediate","filter":"SYNCSTARTDATETIME","dataingestion_filterparam":"2023-04-13T08:31:54","filter_param":"2023-04-13T08:31:54","extraction_sync_dt":"2023-04-13T08:31:54","source_format_regex":"(csv|dat|csv.gz|dat.gz)","inter_query_exec_order":3,"partition_column":"SYNCSTARTDATETIME","clustering_columns":"TRANS_DATE,STORE_CODE,SKU","query_partitioning_threshold":1000000000,"num_partitions":null,"db_partition_column":null,"field_delimiter":"|","is_deleted":false,"created_by":3,"created_at":"2023-05-03T10:09:18.315887+00:00","updated_by":3.0,"updated_at":"2023-05-04T06:26:55.497740+00:00","deleted_by":null,"deleted_at":null}],"message":"Source Mapping.","previous":null,"next":null,"offset":null}));
    return data;
  };

  const getColumns = (
    queryParams,
    levelsJson = {},
    actions = {},
    formatSetAllLabel = false
  ) => {
    const data = {
      total: null,
      page: null,
      count: null,
      status: true,
      data: [
        {
          sub_headers: [],
          tc_code: 1,
          label: "Tenant",
          column_name: "tenant",
          dimension: "Product",
          type: "str",
          is_frozen: true,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 1,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 15,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 2,
          label: "Table",
          column_name: "table",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 2,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 15,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: false,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "View",
          column_name: "view",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 3,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 3,
          label: "Connector",
          column_name: "connector",
          dimension: "Product",
          type: "list",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 4,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 15,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: false,
          width: 200,
          options: [
            { label: "GCS", value: "GCS" },
            { label: "MSSQL", value: "MSSQL" },
            { label: "SFTP", value: "SFTP" },
            { label: "Snowflake", value: "Snowflake" },
          ],
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Source Config",
          column_name: "source_config",
          dimension: "Product",
          type: "list",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 5,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: { data_source: props.dataSourcesDetails, customToolTip: true },
          is_sortable: true,
          options: props.getSourceConfigTooltipData(
            props.dataSourcesDetails.map((data) => {
              let removedMaskedConfig = Object.assign(
                ...Object.keys(data.value)
                  .filter((key) => key !== "password")
                  .map((key) => ({ [key]: data.value[key] }))
              );
              return {
                label: data.name,
                value: data.name,
                otherData: { ...removedMaskedConfig },
              };
            })
          ),
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Pull Type",
          column_name: "pull_type",
          dimension: "Product",
          type: "list",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 6,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
          options: [
            { label: "incremental", value: "incremental" },
            { label: "full", value: "full" },
          ],
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Replace",
          column_name: "replace",
          dimension: "Product",
          type: "ToogleField",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 7,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Schedule Interval",
          column_name: "schedule_interval",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 8,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Intermediate Table",
          column_name: "intermediate_table",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 9,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Filter",
          column_name: "filter",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 10,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Dataingestion Filterparam",
          column_name: "dataingestion_filterparam",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 11,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: { dateFormat: "YYYY-MM-DDTHH:mm:ss" },
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Filter Param",
          column_name: "filter_param",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 12,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: { dateFormat: "YYYY-MM-DDTHH:mm:ss" },
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Extraction sync date Interval",
          column_name: "extraction_sync_dt",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 13,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: { dateFormat: "YYYY-MM-DDTHH:mm:ss" },
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Source Format Regex",
          column_name: "source_format_regex",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 14,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Inter query exec order",
          column_name: "inter_query_exec_order",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 15,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Partition Column",
          column_name: "partition_column",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 16,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Clustering Columns",
          column_name: "clustering_columns",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 17,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Query Partitioning Threshold",
          column_name: "query_partitioning_threshold",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 18,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Num Partitions",
          column_name: "num_partitions",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 19,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Db Partition Column",
          column_name: "db_partition_column",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 20,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Field Delimiter",
          column_name: "field_delimiter",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 21,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Replace Special Characters",
          column_name: "replace_special_characters",
          dimension: "Product",
          type: "ToogleField",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 22,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 1,
          label: "Row count validation info",
          column_name: "row_count_validation_info",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 23,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 30,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: true,
          width: 200,
        },
        {
          label: "Miscellaneous Attributes",
          column_name: "miscellaneous_attributes",
          type: "str",
          is_sortable: true,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 5,
          label: "Created by",
          column_name: "created_by",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 23,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 33,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: false,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 5,
          label: "Created on",
          column_name: "created_at",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 23,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 33,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: false,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 5,
          label: "Updated by",
          column_name: "updated_by",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 23,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 33,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: false,
          width: 200,
        },
        {
          sub_headers: [],
          tc_code: 5,
          label: "Updated at",
          column_name: "updated_at",
          dimension: "Product",
          type: "str",
          is_frozen: false,
          is_editable: false,
          is_aggregated: false,
          order_of_display: 23,
          is_hidden: false,
          is_required: false,
          tc_mapping_code: 33,
          aggregate_type: "",
          formatter: "",
          is_row_span: false,
          footer: "",
          is_searchable: false,
          extra: {},
          is_sortable: false,
          width: 200,
        },
      ],
      message: "Successful",
      previous: null,
      next: null,
      offset: null,
    };
    return agGridColumnFormatter(
      data.data,
      levelsJson,
      actions,
      formatSetAllLabel
    );
  };
  useEffect(async () => {
    if (!props.enabledApplicationsPermission.length) {
      await props.setUserApps();
    }
  }, []);

  useEffect(() => {
    let cols = getColumns();
    if (!userScreenLevelAccess[DELETE])
      cols = cols.filter((col) => col.column_name !== "delete");
    cols = cols.map((col) => {
      if (col.column_name === "dimensions") {
        col.cellRenderer = (params) => {
          return (
            <>
              {params?.data?.dimensions.map((dimension) => {
                return (
                  <Chip
                    size="medium"
                    color="primary"
                    style={{ padding: 10, fontSize: 12 }}
                    label={captializeStringIfCamelCase(
                      dynamicLabelsBasedOnTenant(dimension, "core")
                    )}
                  />
                );
              })}
            </>
          );
        };
      }
      if (col.column_name === "applicable_modules") {
        col.accessor = "screens";
        col.field = "screens";
        col.cellRenderer = (params) => {
          const screens = params.data.screens.map((screen) =>
            screen?.replace(
              /product/gi,
              captializeStringIfCamelCase(
                dynamicLabelsBasedOnTenant("product", "core")
              )
            )
          );
          return <>{screens.toString()}</>;
        };
      }
      if (col.column_name === "created_at") {
        col.accessor = "created_at";
        col.field = "created_at";
        col.cellRenderer = (params) => {
          return (
            <>{moment(params.data.created_at).format("MMM Do YY, hh:mm a")}</>
          );
        };
      }
      if (col.column_name === "updated_at") {
        col.accessor = "updated_at";
        col.field = "updated_at";
        col.cellRenderer = (params) => {
          return (
            <>
              {params.data.updated_at
                ? moment(params.data.updated_at).format("MMM Do YY, hh:mm a")
                : ""}
            </>
          );
        };
      }
      if (col.column_name === "view") {
        col.cellRenderer = (params) => {
          return (
            <Link
              component="button"
              variant="body2"
              onClick={() => {
                props.setselectedView(params.data);
                props.setViewModal(true);
              }}
            >
              {params.data.view}
            </Link>
          );
        };
      }
      return col;
    });
    setfilterConfigsTableColumns(cols);
  }, [userScreenLevelAccess]);

  useEffect(() => {
    const fetchFilterConfigTableColumns = async () => {
      let data = await getTenantFilterConfig();
      configTableData.length = 0;
      if(props.csvUploadedData?.[0])
        if(data.data?.[0])
          setConfigTableData([...props.csvUploadedData,...data.data]);
        else
          setConfigTableData([...props.csvUploadedData])
      else
        setConfigTableData(data.data);
    };
    fetchFilterConfigTableColumns();
  }, []);


  const onCellValueChanged = (params, nestingLevel) => {
    const { value, rowIndex, oldValue, colDef } = params;
    onSaveHandler(params.data, colDef.field);
  };

  const validateInput = (data, field) => {
    if (
      [
        "inter_query_exec_order",
        "query_partitioning_threshold",
        "num_partitions",
      ].includes(field)
    ) {
      if (data[field].match(/^\d+$/)) return true;
      displaySnackMessages(
        "Enter valid " + `${field}` + " integer value",
        "error"
      );
      return false;
    } else {
      if (typeof data[field] === "string") {
        if (data[field].length >= 1) return true;
        displaySnackMessages("Enter valid " + `${field}` + " value", "error");
        return false;
      }
    }
    return true;
  };

  const onSaveHandler = (payload, field) => {
    const { table, view } = payload;
    let validate = validateInput(payload, field);
    const saveTenantFilterConfig = async () => {
      if (!screenConfig) return;
      try {
        let saveTenantFilterConfigPayload = {
          // config_value: screenConfig,
          // update_config : [payload]
          table,
          view,
          [field]: payload[field],
        };
        let tenantFilterConfigResponse = await props.saveMappingTableConfig(
          // props.appInfo?.applicationCode,
          0,
          saveTenantFilterConfigPayload
        );
        if (tenantFilterConfigResponse?.status) {
          props.setRenderMappingAgGrid(false);
          props.addSnack({
            message:
              tenantFilterConfigResponse?.message || "Configuration updated!",
            options: {
              variant: "success",
            },
          });
        } else {
          props.addSnack({
            message:
              tenantFilterConfigResponse?.message ||
              "Updating new configuration failed!",
            options: {
              variant: "error",
            },
          });
          configMappingTableRef.current.api.refreshServerSideStore({
            purge: true,
          });
        }

        // setLoading(false);
      } catch (e) {
        // setLoading(false);
        props.addSnack({
          message:
            e?.response?.data?.message || "Updating new configuration failed!",
          options: {
            variant: "error",
          },
        });
      }
    };
    if (validate) saveTenantFilterConfig();
    props.setRenderMappingAgGrid(true);
  };

  const displaySnackMessages = (message, variance) => {
    props.addSnack({
      message: message,
      options: {
        variant: variance,
      },
    });
  };

  const onSelectionChanged = (event) => {
    // fetch all selected rows
    let selections = event.api.getSelectedRows();
    props.setSelectedRows([...selections]);
  };

  const onEditHandler = (data)  => {
    props.onEdit(data.data);
  }

  const rowClassRules = useMemo(() => {
    return {
      [classes.highLightUploadedData]: (params) => params.data.is_uploaded
    };
  }, [classes.highLightUploadedData]);

  return (
    <LoadingOverlay loader={isLoading} spinner>
        <ConfirmPrompt
          showModal={showDeleteConfirmModal}
          title="Confirm Delete"
          message="Are you sure you want to delete the mapping ?"
          ariaLabeledBy="save-changes-dialog"
          primaryBtnText="Yes"
          secondaryBtnText="No"
          setConfirm={updateShowDeleteConfirmModal}
          confirmCallback={(val) => {
            if (val) {
              deleteMappingConfig(currentConfigToDelete);
            }
            updateCurrentConfigToDelete(null);
          }}
        />
        {filterConfigsTableColumns.length > 0 && (
          <AgGridComponent
            downloadAsCSV={configTableData && configTableData.length>0}
            downloadTemplate={!(configTableData && configTableData.length>0)}
            handleDownloadCSVTemplate={()=>handleDownloadCSVTemplate(MAPPING_TABLE_COLS)}
            tableRef={configMappingTableRef}
            callDeleteApi={(data) => {
              updateShowDeleteConfirmModal(true);
              updateCurrentConfigToDelete(data);
            }}
            onEditClick={(params) => onEditHandler(params)}
            // onCellValueChanged={(params) => onCellValueChanged(params)}
            columns={filterConfigsTableColumns}
            rowdata={configTableData}
            loadTableInstance={(gridInstance) => {
              configMappingTableRef.current = gridInstance;
            }}
            sizeColumnsToFitFlag={true}
            adjustTableHeightServerSide={true}
            selectAllHeaderComponent={true}
            onSelectionChanged={onSelectionChanged}
            uniqueRowId={"table"}
            rowSelection={"single"}
            rowClassRules={rowClassRules}
          />
        )}
      </LoadingOverlay>
  );
};

SourceMappingConfigTable.propTypes = {
  setSelectedRows: PropTypes.func,
  csvUploadedData: PropTypes.func,

}

const mapStateToProps = (state) => {
  return {
    createdConfigs: state.filterElementsReducer.createdConfigs,
    configs: state.filterElementsReducer.configs,
    selectedModuleConfigData:
      state.filterElementsReducer.selectedModuleConfigData,
    enabledApplicationsPermission: state.homePageReducer.userAppsPermission,
    dataSourcesDetails: state.dataIngestionReducer.dataSourcesDetails,
  };
};
const mapActionsToProps = {
  updateFilterConfig,
  resetFilterConfigSelections,
  getFilterConfigsTableData,
  addSnack,
  saveIngestionConfig,
  saveMappingTableConfig,
  getFilterConfigById,
  setModuleConfigData,
  getFilteredFields,
  setFilteredFields,
  setMandatoryFieldsInScreen,
  deleteMappingConfig,
  setUserApps: homePageActions,
  getModuleLevelAccess,
  updateSubModuleStatus
};
export default connect(
  mapStateToProps,
  mapActionsToProps
)(SourceMappingConfigTable);
